import { render, staticRenderFns } from "./IKMonitoramentoDocumentos.vue?vue&type=template&id=1f6c8462&"
import script from "./IKMonitoramentoDocumentos.vue?vue&type=script&lang=js&"
export * from "./IKMonitoramentoDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports